import React from "react";
import PropTypes from "prop-types";
import Dispatcher from "Dispatcher";
import HexActions from "lib/hex/HexActions";
import { useOrgLookup } from "lib/hex/lib/resultsview/ResultsView";

export default function ParametersTemplate(props) {
    const {data} = props;
    const {
        params,
        typeName,
        typeKey,
        allowRerun,
    } = data;
    if (!params._human) {
        // it's an old-style one...
        if (params.human) {
            // for Generic XML exports
            const {label, human: text} = params;
            params._human = {
                label,
                text,
            };
        } else if (params.particid) {
            // for the society exports/harvests
            const {particid, start, end, quarter, year} = params;
            let startDate = "";
            if (start != null) {
                startDate = new Date(start).toLocaleDateString();
            }
            let endDate = "";
            if (end != null) {
                if (start != null) {
                    endDate = " - ";
                }
                endDate += new Date(end).toLocaleDateString();
            }
            let quarterString = "";
            if (quarter != null) {
                quarterString = `${year}Q${quarter}`;
            }
            params._human = {
                text: `Participant ID: ${particid}, ${startDate}${endDate}${quarterString}`,
            };
        }
    }
    let body;
    if (params._human) {
        const {label, text} = params._human;
        body = <React.Fragment>
            {label && <label>{label}</label>}
            {text}
        </React.Fragment>;
    } else { // just dump 'em all out
        body = Object.keys(params)
            .filter(p => p.charAt(0) !== "_" && params[p])
            .map(p => {
                let value = params[p].toString();
                if (p === "query") {
                    value = value
                        .replace(/&&/g, " && ")
                        .replace(/\|\|/g, " || ");
                }
                return <div key={p}>
                    <label>{p}</label>
                    {value}
                </div>;
            });
    }
    const orgLookup = useOrgLookup();
    const members = React.useMemo(
        () => {
            if (!params.activeMembers) return null;
            return params.activeMembers
                .split(",")
                .map(k => orgLookup.hasOwnProperty(k) ? orgLookup[k].name || k : k)
                .sort();
        },
        [orgLookup, params.activeMembers],
    );
    return <React.Fragment>
        {allowRerun && <button
            className={"rerun-export btn btn-link btn-small"}
            title={`Rerun this ${typeName}`}
            onClick={() => Dispatcher.dispatch({
                type: HexActions.RERUN_EXPORT,
                typeKey,
                params,
            })}
        >
            <i className={"glyphicon glyphicon-refresh"} />
        </button>}
        {body}
        {members && <div>
            <label>Data {members.length === 1 ? "Owner" : "Owners"}</label>
            {members.join(", ")}
        </div>}
    </React.Fragment>;
}

ParametersTemplate.propTypes = {
    data: PropTypes.shape({
        params: PropTypes.object.isRequired,
        typeName: PropTypes.string.isRequired,
        typeKey: PropTypes.string.isRequired,
        allowRerun: PropTypes.bool,
    }).isRequired,
};



// WEBPACK FOOTER //
// ./app/lib/hex/lib/resultsview/templates/ParametersTemplate.js